const defaultUIState = {
  hideHeader: false,
  hideTopBar: false,
  hideContacts: false,
  hideSocials: false,
  hideTheme: false,
  hideLang: false,
  hideFav: false,
  hideNav: false,
  hideClose: false,
  hideCatalogSelect: false,
};

export default {
  state: () => ({
    ...defaultUIState,
  }),
  mutations: {
    SET_HIDE_HEADER(state, value) {
      state.hideHeader = value;
    },
    SET_HIDE_TOP_BAR(state, value) {
      state.hideTopBar = value;
    },
    SET_HIDE_CONTACTS(state, value) {
      state.hideContacts = value;
    },
    SET_HIDE_SOCIALS(state, value) {
      state.hideSocials = value;
    },
    SET_HIDE_THEME(state, value) {
      state.hideTheme = value;
    },
    SET_HIDE_LANG(state, value) {
      state.hideLang = value;
    },
    SET_HIDE_FAV(state, value) {
      state.hideFav = value;
    },
    SET_HIDE_NAV(state, value) {
      state.hideNav = value;
    },
    SET_HIDE_CATALOG_SELECT(state, value) {
      state.hideCatalogSelect = value;
    },
  },
  actions: {
    SET_HIDE_HEADER({ commit }, value) {
      commit('SET_HIDE_HEADER', value);
    },
    SET_HIDE_TOP_BAR({ commit }, value) {
      commit('SET_HIDE_TOP_BAR', value);
    },
    SET_HIDE_CONTACTS({ commit }, value) {
      commit('SET_HIDE_CONTACTS', value);
    },
    SET_HIDE_SOCIALS({ commit }, value) {
      commit('SET_HIDE_SOCIALS', value);
    },
    SET_HIDE_THEME({ commit }, value) {
      commit('SET_HIDE_THEME', value);
    },
    SET_HIDE_LANG({ commit }, value) {
      commit('SET_HIDE_LANG', value);
    },
    SET_HIDE_FAV({ commit }, value) {
      commit('SET_HIDE_FAV', value);
    },
    SET_HIDE_NAV({ commit }, value) {
      commit('SET_HIDE_NAV', value);
    },
    SET_HIDE_CLOSE({ commit }, value) {
      commit('SET_HIDE_NAV', value);
    },
    SET_HIDE_CATALOG_SELECT({ commit }, value) {
      commit('SET_HIDE_CATALOG_SELECT', value);
    },

    PARSE_AND_SET_UI_STATE({ dispatch }, uiParam) {
      if (!uiParam) return;
      const keys = uiParam
        .split(',')
        .map((k) => k.trim())
        .filter(Boolean);

      const allowed = [
        'hideHeader',
        'hideTopBar',
        'hideContacts',
        'hideSocials',
        'hideTheme',
        'hideLang',
        'hideFav',
        'hideNav',
        'hideClose',
        'hideCatalogSelect',
      ];
      keys.forEach((key) => {
        if (allowed.includes(key)) {
          const actionName =
            'SET_' +
            key
              .split(/(?=[A-Z])/)
              .join('_')
              .toUpperCase();
          dispatch(actionName, true);
        }
      });
    },
  },
  getters: {
    hideHeader: (state) => state.hideHeader,
    hideTopBar: (state) => state.hideTopBar,
    hideBottomBar: (state) => state.hideBottomBar,
    hideContacts: (state) => state.hideContacts,
    hideSocials: (state) => state.hideSocials,
    hideTheme: (state) => state.hideTheme,
    hideLang: (state) => state.hideLang,
    hideFav: (state) => state.hideFav,
    hideNav: (state) => state.hideNav,
    hideClose: (state) => state.hideClose,
    hideCatalogSelect: (state) => state.hideCatalogSelect,
  },
};
